<template>
  <v-layout class="white elevation-1">
    <v-card-text>
      Log Mode
      <v-divider></v-divider>
      <v-checkbox
        v-model="options.signMode"
        label="Sign In"
        color="secondary"
        value="in"
      ></v-checkbox>
      <v-checkbox
        v-model="options.signMode"
        label="Sign Out"
        color="secondary"
        value="out"
      ></v-checkbox>
    </v-card-text>
    <v-card-text>
      Date Range
      <v-divider></v-divider>
      <calendar v-model="options.fromDate" placeholder="From Date" />
      <calendar v-model="options.toDate" placeholder="To Date" />
    </v-card-text>
    <v-card-text v-if="name">
      Name
      <v-divider></v-divider>
      <v-text-field
        v-model="options.firstName"
        label="First Name"
      ></v-text-field>
      <v-text-field v-model="options.lastName" label="Last Name"></v-text-field>
    </v-card-text>
    <slot name="class"></slot>
    <slot name="wwcc"></slot>
    <v-spacer></v-spacer>
    <v-btn icon color="primary" small @click="clear">
      <v-icon>clear</v-icon>
    </v-btn>
  </v-layout>
</template>

<script>
/* eslint-disable */
import Calendar from "../../views/reports/FilterCalendar";
export default {
  components: {
    Calendar,
  },
  props: {
    name: Boolean,
    value: {
      type: Object,
    },
  },
  data() {
    return {
      options: this.value,
    };
  },
  watch: {
    options: {
      handler: function (val) {
        this.$emit("input", this.options);
      },
      deep: true,
    },
  },
  methods: {
    clear: function () {
      this.options.signMode = [];
      this.options.firstName = "";
      this.options.lastName = "";
      this.options.fromDate = new Date().toISOString().split("T")[0];
      this.options.toDate = new Date().toISOString().split("T")[0];
      this.$emit("clear");
    },
  },
};
</script>
